import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home.vue')
const CertificateQuery = () => import('@/views/CertificateQuery.vue')
const About = () => import('@/views/About.vue')

export default new VueRouter({
  mode: 'hash',
  routes: [
    { path: '/', name: 'home', component: Home, meta: { title: '首页' } },
    {
      path: '/query',
      name: 'query',
      component: CertificateQuery,
      meta: { title: '证书查询' }
    },
    { path: '/about', name: 'about', component: About, meta: { title: '关于 ACAA' } },
    { path: '*', redirect: '/' }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})
